import { all, put, take, takeLatest } from 'redux-saga/effects';
import {
    CLEAR_AUTOMATION_CONDITIONS,
    CLEAR_BUCKETS,
    CLEAR_DEVICE_VERIFICATION_READINGS,
    CLEAR_DEVICE_VERIFICATIONS,
    CLEAR_DEVICES,
    CLEAR_INDICATORS,
    CLEAR_INSTALLATION_ZONES,
    CLEAR_MEASUREMENTS,
    FETCH_AUTOMATION_CONDITIONS,
    FETCH_BUCKETS,
    FETCH_DEVICE_VERIFICATION_READINGS,
    FETCH_DEVICE_VERIFICATIONS,
    FETCH_DEVICES,
    FETCH_INDICATORS,
    FETCH_INSTALLATION_ZONES,
    FETCH_MEASUREMENTS,
    FETCH_SITE,
    FULFILLED,
    LOAD_SITE,
    REFRESH_SITE
} from './actionTypes';

// actions
export const loadSite = id => ({
    type: LOAD_SITE,
    payload: id
});

export const refreshSite = id => ({
    type: REFRESH_SITE,
    payload: id
});

// reducer
let newState;

export default (state = {}, { type, payload }) => {
    switch (type) {
        case LOAD_SITE:
        case REFRESH_SITE:
            newState = { ...state };
            delete newState[payload];
            return newState;

        case LOAD_SITE + FULFILLED:
            return { ...state, [payload]: true };

        default:
            return state;
    }
};

// sagas
function* loadSiteSaga({ payload: site_id }) {
    try {
        yield put({ type: FETCH_AUTOMATION_CONDITIONS, payload: { site_id } });
        yield put({ type: FETCH_BUCKETS, payload: { site_id } });
        yield put({ type: FETCH_DEVICES, payload: { site_id } });
        yield put({ type: FETCH_DEVICE_VERIFICATIONS, payload: { site_id } });
        yield put({ type: FETCH_DEVICE_VERIFICATION_READINGS, payload: { site_id } });
        yield put({ type: FETCH_INDICATORS, payload: { site_id, type: 'raw' } });
        yield put({ type: FETCH_INSTALLATION_ZONES, payload: { site_id } });
        yield put({ type: FETCH_MEASUREMENTS, payload: { site_id } });
        yield put({ type: FETCH_SITE, payload: site_id });
        yield all([
            take(FETCH_AUTOMATION_CONDITIONS + FULFILLED),
            take(FETCH_BUCKETS + FULFILLED),
            take(FETCH_DEVICES + FULFILLED),
            take(FETCH_DEVICE_VERIFICATIONS + FULFILLED),
            take(FETCH_DEVICE_VERIFICATION_READINGS + FULFILLED),
            take(FETCH_INDICATORS + FULFILLED),
            take(FETCH_INSTALLATION_ZONES + FULFILLED),
            take(FETCH_MEASUREMENTS + FULFILLED),
            take(FETCH_SITE + FULFILLED)
        ]);
        yield put({ type: LOAD_SITE + FULFILLED, payload: site_id });
    } catch (error) {
        console.error(error);
    }
}

function* watchLoad() {
    yield takeLatest(LOAD_SITE, loadSiteSaga);
}

function* refreshSiteSaga({ payload: site_id }) {
    try {
        yield put({ type: CLEAR_AUTOMATION_CONDITIONS, payload: site_id });
        yield put({ type: CLEAR_BUCKETS, payload: site_id });
        yield put({ type: CLEAR_DEVICES, payload: site_id });
        yield put({ type: CLEAR_DEVICE_VERIFICATIONS, payload: site_id });
        yield put({ type: CLEAR_DEVICE_VERIFICATION_READINGS, payload: site_id });
        yield put({ type: CLEAR_INDICATORS, payload: site_id });
        yield put({ type: CLEAR_INSTALLATION_ZONES, payload: site_id });
        yield put({ type: CLEAR_MEASUREMENTS, payload: site_id });
        yield put({ type: LOAD_SITE, payload: site_id });
    } catch (error) {
        console.error(error);
    }
}

function* watchRefresh() {
    yield takeLatest(REFRESH_SITE, refreshSiteSaga);
}

const sagas = [
    watchLoad,
    watchRefresh
];

export { sagas };
